import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext, useMemo } from 'react';

import { useContent } from '../../../hooks/useContent';
import { MaxLengths } from '../../../utils/constants';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function EmailInput() {
  const { bindEmail, invalidFields } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'email', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('email') ? getContentByPath('accountCreation.fields.email.error') : undefined,
    [getContentByPath, invalidFields],
  );

  return (
    <TextInput
      variant='default'
      label={getContentByPath('accountCreation.fields.email.title')}
      id='email'
      disabled
      icon='lock'
      error={!!error}
      hint={error}
      testId='email'
      {...bindEmail}
      maxLength={MaxLengths.Email}
      type='email'
      autoComplete='email'
    />
  );
}

EmailInput.displayName = 'EmailInputField';
